import { ascending, rollup } from 'd3'

/**
 * 1 Row per entity
 * @param {*} entitiesResponse
 * @returns
 */
export function makeRows (entitiesTrackings, browserAppAccount) {
  if (!browserAppAccount) return []
  if (!Array.isArray(browserAppAccount.data?.entities)) return []
  if (browserAppAccount.data?.entities.length === 0) return []

  const trackingsMap = rollup(entitiesTrackings,
    (values) => {
      return {
        categoryOptions: values,
        category: {
          id: values[0].category_id,
          name: values[0].category_name,
          status: values[0].category_status
        },
        accountingOrganisation: {
          id: values[0].accounting_organisation_id
        }
      }
    },
    (d) => d.accounting_organisation_id,
    (d) => d.category_name
  )
  console.log('rollup', trackingsMap)

  browserAppAccount.data.entities.forEach(entity => {
    entity.entityTrackingsMap = trackingsMap.get(entity.id)
  })

  const rows = Array.from(browserAppAccount.data.entities)

  rows.sort(function (a, b) {
    return ascending(a.name, b.name)
  })

  return rows
}
